import React, { FC } from 'react';
import { Medium } from "@/constants/mediums";
import ReadingsPage from "@/components/readings/ReadingsPage";

const WaterReadingsPage: FC = () => {
  return <ReadingsPage medium={Medium.water} />;
};

export default WaterReadingsPage;
